import { rackSize, rackSizeFullName } from "../types/index.const";

const rackSizeOptions = rackSize.map((el, index) => ({
  label: rackSizeFullName[index],
  value: el,
}));

export default rackSizeOptions;
